import { useEffect, useState } from 'react';

import type { Method } from '@luna/api';
import { logger } from '@luna/logger';

import { getImageData, isAssetsImage, isImageData } from './useSecureImageService';

interface SecureImage {
    isLoading: boolean;
    imageData: string | undefined;
}

export function useSecureImage(
    imageUrl?: string,
    sendAcceptHeader = false,
    method: Method = 'GET',
    sendImageVariant = true,
): SecureImage {
    const [imageData, setImageData] = useState<string>();
    const isLoadingInitially = !!imageUrl && !(isImageData(imageUrl) || isAssetsImage(imageUrl));
    const [isLoading, setIsLoading] = useState(isLoadingInitially);

    useEffect(() => {
        if (!imageUrl) {
            return;
        }

        if (isImageData(imageUrl) || isAssetsImage(imageUrl)) {
            setImageData(imageUrl);
            return;
        }

        setIsLoading(true);
        getImageData(imageUrl, sendAcceptHeader, method, sendImageVariant)
            .then((data) => {
                if (!data) {
                    setImageData(undefined);
                    return;
                }
                setImageData(`data:image/png;base64,${data}`);
            })
            .catch((err) => {
                logger.error(err);
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, [imageUrl, method, sendAcceptHeader]);

    return {
        isLoading,
        imageData,
    };
}
